// Shared palette constants for places that need JS values (inline styles, SVG,
// framer-motion). Mirrors the CSS tokens in index.css and tailwind.config.js.
export const palette = {
  beige50: '#FBF7EF',
  beige100: '#F4EDDF',
  beige200: '#EBE3D1',
  beige300: '#DED3BC',
  navy500: '#38638F',
  navy600: '#274F79',
  navy700: '#1E3E63',
  navy800: '#182F4C',
  navy900: '#132639',
  ink900: '#23262B',
  ink600: '#565B62',
  ink400: '#8B8F97',
  line: '#E4DAC6',
  onNavy: '#EFE9DC',
  onNavyMuted: '#A6C0DB',
};

// Faint "graph paper" grid used on navy bands — structure, not decoration.
export const navyGrid = {
  backgroundImage:
    'linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)',
  backgroundSize: '44px 44px',
};
